<div>

    <div>
        {{ 'bikeshop.modal.initiate.refund.stripe_terms' | translate }}
    </div>

    <div class="row margin-top-8">
        <div class="col-md-5 label" [ngClass]="{'red': !selectedTransaction }">
            {{ "bikeshop.modal.initiate_refund.select_transaction_to_refund" | translate }}:
        </div>
        <div class="col-md-7 value">
            <p-dropdown [options]="refundOptions" [(ngModel)]="selectedTransaction" optionLabel="label"></p-dropdown>
        </div>
    </div>
    <div class="row margin-top-8">
        <div class="col-md-5 label" [ngClass]="{'red': !isValid()}">
            {{ "bikeshop.modal.initiate_refund.enter_amount_to_refund" | translate : {maxAmount: partner.CurrencySymbol
            + maxRefundAmount()} }}:
        </div>
        <div class="col-md-7 value">
            <input pInputText type="number" [(ngModel)]="refundAmount" />
        </div>
    </div>
    <div class="row margin-top-16">
        <div class="col-md-5"></div>
        <div class="col-md-7">
            <div *ngIf="!busyRefunding">
                <button pButton type="button" [disabled]="!isValid()" class="p-button-raised full-width accent"
                    (click)="refundPayment()"
                    label="{{'bikeshop.modal.initiate_refund.refund_payment'| translate}}"></button>
            </div>
            <div *ngIf="busyRefunding" class="flex" style="justify-content: center;">
                <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
                </p-progressSpinner>
            </div>
        </div>
    </div>
    <div class="row margin-top-16" *ngIf="errorMessage">
        <div class="col-md-12 bold red">{{errorMessage}}</div>
    </div>

</div>